export const companyAssests = [
  {
    company_id: "r0023",
    images: ["/assets/images/pi/logo.jpg"],
    videos: ["https://www.youtube.com/embed/hL9RbDmfbn0"],
    thumbs: ["/assets/images/pi/logo.jpg", "/assets/images/pi/videothumb.jpg"],
    present: "/assets/docs/pi/present.pdf",
  },
  {
    company_id: "l1034",
    images: ["/assets/images/tn/logo.png"],
    videos: [
      "/assets/videos/tn/aepscw&be.mp4",
      "/assets/videos/tn/dmt.mp4",
      "/assets/videos/tn/recharge&reports.mp4",
    ],
    thumbs: [
      "/assets/images/tn/logo.png",
      "/assets/images/tn/video1.PNG",
      "/assets/images/tn/video2.PNG",
      "/assets/images/tn/video3.PNG",
    ],
    present: "/assets/docs/tn/present.pdf",
  },
  {
    company_id: "r7845",
    images: ["/assets/images/lamp/logo.jpg"],
    videos: ["/assets/videos/lamp/lamp.mp4"],
    thumbs: ["/assets/images/lamp/logo.jpg", "/assets/images/lamp/video.PNG"],
    present: "/assets/docs/lamp/present.pdf",
  },
];
